(function() {
  var AccessController, InserterHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  InserterHandler = App.loadClass('admin::handlers/inserter/InserterHandler');

  exports.InserterController = (function(superClass) {
    extend(InserterController, superClass);

    function InserterController(scope, http) {
      var ref;
      this.scope = scope;
      this.http = http;
      InserterController.__super__.constructor.call(this, 'inserter', this.http);
      App.current_page = new InserterHandler();
      if ((ref = App.sidebar) != null) {
        if (typeof ref.open === "function") {
          ref.open();
        }
      }
      App.current_page.init();
    }

    return InserterController;

  })(AccessController);

}).call(this);
